export default {
    data: () => ({
        rewardMethods: [
            {
                name: {
                    el: "Πληρωμές με Μετρητά - Offline Συναλλαγές",
                    en: "Cash Payments - Offline Transactions",
                    it: "Pagamenti in contanti - Transazioni offline"
                },
                description: {
                    el: "Ανταμείψτε τον πελάτη με πόντους χειροκίνητα χρησιμοποιώντας τον αριθμό της κάρτας ή του κινητού του.",
                    en:
                        "Reward the customer with points manually by using their loaylty card or mobile number.",
                    it: "Premia il cliente con punti manualmente utilizzando la carta fedeltà o il numero di cellulare."
                },
                active: false,
                system_notification_id: null,
                component: "SendPoints",
                updateProp: "offline_transaction",
                loading: false,
                commit: "storePanel/setSendPointsActivator",
                successText: "send points activator",
                permission: "settings.reward.cash_payments"
            },
            {
                name: { el: "RoadCube POS", en: "RoadCube POS", it: "RoadCube POS" },
                description: {
                    el: "Οι πελάτες κερδίζουν πόντους μέσω των συσκευών IOT RoadCube δίπλα στο ταμείο.",
                    en:
                        "Customers win points through the RoadCube IOT devices next to the cashier.",
                    it: "I clienti guadagnano punti attraverso i dispositivi RoadCube IOT accanto alla cassa."
                },
                active: false,
                component: "PointDelivery",
                updateProp: "pos_points_delivery",
                loading: false,
                commit: "storePanel/setPointDeliveryActivator",
                successText: "point delivery activator",
                permission: "settings.reward.pos"
            },
            {
                name: { el: "Online Επεξεργασία Πληρωμών", en: "Online Payment Processing", it: "Elaborazione dei pagamenti online" },
                description: {
                    el: "Οι πελάτες κερδίζουν πόντους αγοράζοντας προϊόντα online μέσω της εφαρμογής για κινητά (τη δική σας ή την εφαρμογή RoadCube).",
                    en:
                        "Customers win points by purchasing products online through the mobile app (yours or the RoadCube app).",
                    it: "I clienti guadagnano punti acquistando prodotti online tramite l'app mobile (la tua o l'app RoadCube)."
                },
                active: false,
                component: "MobilePayments",
                updateProp: "online_payment_processing",
                loading: false,
                commit: "storePanel/setMobilePayments",
                successText: "mobile payments",
                permission: "settings.reward.online_payment_processing"
            },
            {
                name: { el: "Σάρωση απόδειξης", en: "Receipt Scanning", it: "Scansione Scontrini" },
                description: {
                    el: "Οι πελάτες κερδίζουν πόντους καθώς σαρώνουν αποδείξεις μέσω της εφαρμογής για κινητά (τη δική σας ή την εφαρμογή RoadCube).",
                    en:
                        "Customers win points as they scan receipts through the mobile app (yours or the RoadCube app).",
                    it: "I clienti guadagnano punti scansionando le ricevute tramite l'app mobile (la tua o l'app RoadCube)."
                },
                active: false,
                component: "ScanReceipt",
                updateProp: "open_receipt",
                loading: false,
                commit: "storePanel/setScanReceiptActivator",
                successText: "scan receipt activator",
                permission: "settings.reward.receipt_scanning"
            },
            {
                name: { el: "Check In", en: "Check In", it: "Check In" },
                description: {
                    el: "Οι πελάτες κερδίζουν πόντους όταν επισκέπτονται το κατάστημά σας.",
                    en:
                        "Customers win points when they visit your store.",
                    it: "I clienti guadagnano punti quando visitano il tuo negozio."
                },
                active: false,
                component: "RewardWithPresence",
                updateProp: "open_checkin",
                loading: false,
                commit: "storePanel/setRewardWithPresence",
                successText: "reward with presence",
                permission: "settings.reward.check_in"
            },
            {
                name: {
                    el: "Παραγγελίες",
                    en: "Orders",
                    it: "Ordini"
                },
                description: {
                    el: "Οι πελάτες κερδίζουν πόντους δημιουργώντας παραγγελίες από το strore σας μέσω της εφαρμογής για κινητά, για παράδοση ή παραλαβή.",
                    en:
                        "Customers win points by creating orders from your strore through the mobile app, for delivery or pickup.",
                    it: "I clienti guadagnano punti quando visitano il tuo negozio."
                },
                active: false,
                component: "DeliverySettings",
                updateProp: "orders_allowed",
                loading: false,
                commit: "storePanel/setOrders",
                successText: "orders activator",
                permission: "settings.reward.orders"
            }
        ]
    })
};
